import RatioBar from "@/elements/RatioBar/RatioBar";
import { cn, putComma } from "@/lib/utils";
import { updateField } from "@/store/features/stocksDetailsSlice";
import { memo, useMemo } from "react";
import { SlArrowDown } from "react-icons/sl";
import { useDispatch, useSelector } from "react-redux";

function StockMarketDepth({ mbp, totalSellQty, totalBuyQty }) {
    const data = useMemo(() => mbp, [mbp]);
    const dispatch = useDispatch();
    const { isMarketDepthBfOpen } = useSelector((state) => state.stocksDetails);

    return (
        <div className="p-4 font-Inter select-none">
            <div
                className="flex justify-between cursor-pointer"
                onClick={() => dispatch(updateField({ field: "isMarketDepthBfOpen", value: !isMarketDepthBfOpen }))}
            >
                <div className="text-sm font-semibold text-black">Market depth</div>
                <div className="text-sm font-semibold text-black">
                    <SlArrowDown
                        size={16}
                        className={cn(isMarketDepthBfOpen ? "rotate-180" : "rotate-0", "transition-all")}
                    />
                </div>
            </div>
            <div className={`transition-all overflow-hidden ${isMarketDepthBfOpen ? "max-h-[600px]" : "max-h-0"}`}>
                <div className="mt-4 flex gap-6">
                    <div className="basis-1/2">
                        <div className="flex justify-between">
                            <div className="text-xs text-[#414141] font-medium">Qty.</div>
                            <div className="text-xs text-[#414141] font-medium">Bid</div>
                        </div>
                        <div className="flex flex-col gap-2 py-3">
                            {data?.map((ele, i) => {
                                let maxQuantity = Math.max(...data?.map((ele) => ele?.ibuyQty));
                                return (
                                    <div className="flex justify-between p-1 overflow-hidden rounded relative " key={i}>
                                        <div
                                            className="ease-in-out duration-300 rounded-s absolute left-0 top-0 bottom-0 bg-[#DCEDE7] "
                                            style={{ right: `${100 - (ele.ibuyQty / maxQuantity) * 100}%` }}
                                        />
                                        <div className="text-[10px] text-[#414141] font-medium z-[1]">
                                            {putComma(ele.ibuyQty, 0)}
                                        </div>
                                        <div className="text-[10px] text-[#414141] font-medium z-[1]">
                                            {putComma(ele.fbuyPrice)}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="basis-1/2">
                        <div className="flex justify-between">
                            <div className="text-xs text-[#414141] font-medium">Ask</div>
                            <div className="text-xs text-[#414141] font-medium">Qty.</div>
                        </div>
                        <div className="flex flex-col gap-2 py-3">
                            {data?.map((ele, i) => {
                                let maxQuantity = Math.max(...data?.map((ele) => ele?.isellQty));
                                return (
                                    <div className="flex justify-between p-1 rounded overflow-hidden relative" key={i}>
                                        <div
                                            className="ease-in-out duration-300 rounded-e absolute right-0 top-0 bottom-0 bg-[#FAE6DF] "
                                            style={{ left: `${100 - (ele.isellQty / maxQuantity) * 100}%` }}
                                        />
                                        <div className="text-[10px] text-[#414141] font-medium z-[1]">
                                            {putComma(ele.fsellPrice)}
                                        </div>
                                        <div className="text-[10px] text-[#414141] font-medium z-[1]">
                                            {putComma(ele.isellQty, 0)}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="flex flex-row justify-between mt-4 mb-2">
                    <div className="text-xs font-medium text-[#414141]">Total Buy Qty.</div>
                    <div className="text-xs font-medium text-[#414141]">Total Sell Qty.</div>
                </div>
                <RatioBar percent={(totalBuyQty * 100) / (totalBuyQty + totalSellQty)} className="w-full" />
                <div className="flex flex-row justify-between mt-2 ">
                    <div className="text-xs font-medium">
                        <b>{((totalBuyQty * 100) / (totalBuyQty + totalSellQty))?.toFixed(2)}%</b> (
                        {putComma(totalBuyQty, 0)})
                    </div>
                    <div className="text-xs font-medium">
                        ({putComma(totalSellQty, 0)}){" "}
                        <b>{((totalSellQty * 100) / (totalBuyQty + totalSellQty))?.toFixed(2)}%</b>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default memo(StockMarketDepth);
